import { render, staticRenderFns } from "./SubmitToUniversity.vue?vue&type=template&id=f23dd5be&"
import script from "./SubmitToUniversity.vue?vue&type=script&lang=js&"
export * from "./SubmitToUniversity.vue?vue&type=script&lang=js&"
import style0 from "./SubmitToUniversity.vue?vue&type=style&index=0&id=f23dd5be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports